module.exports = __webpack_public_path__ + "static/media/kit.ef7c99bf.jpg";